export default __webpack_public_path__ + "static/media/empty.b408b468.svg";